import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

interface RiskAreaEntityAccess {
    hasAccessToAllEntities: boolean;
}

export function useRiskAreaEntityAccess(riskAreaId: string | undefined) {
    const { data } = useDotLegalQuery<RiskAreaEntityAccess>(`/risk-areas/${riskAreaId}/entities/access`, { enabled: !!riskAreaId });

    // Default to full access until the check resolves so the banner never flashes on a page that turns out
    // to be fully accessible.
    return { hasAccessToAllEntities: data?.hasAccessToAllEntities ?? true };
}
